
import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the current view is mobile sized
 * Returns true if screen width is below 768px (md breakpoint in Tailwind)
 */
export function useMobile() {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Set initial value
    checkMobile();
    
    // Add event listener
    window.addEventListener('resize', checkMobile);
    
    // Clean up
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  return isMobile;
}

// Add alias for backward compatibility if needed
export const useIsMobile = useMobile;
